import {
  Button,
  GroupTextField,
  Icon,
  Input,
  TextField,
} from "@elaniintc/goes-design-system";
import { useState, type ComponentProps } from "react";
import { useEntity } from "../context";

interface RolesListProps extends ComponentProps<typeof TextField> {
  initialItems?: string[];
}

export const RolesList = ({ label, placeholder, required }: RolesListProps) => {
  const [configSelectNewItem, setConfigSelectNewItem] = useState<string>("");
  const { rolesList, addRole, removeRole } = useEntity();

  const handleAddSelectItem = () => {
    const v = configSelectNewItem.trim();
    if (!v) return;
    addRole(v);
    setConfigSelectNewItem("");
  };

  const handleRemoveSelectItem = (id: string) => {
    removeRole(id);
  };

  return (
    <>
      <div className="flex items-end pt-4">
        <GroupTextField
          className="w-full"
          label={label}
          labelHelperText="Opcional"
          required={required}
        >
          <Input
            className="w-full"
            placeholder={placeholder}
            value={configSelectNewItem}
            onChange={(e) => setConfigSelectNewItem(e.target.value)}
          />
          <Button
            className="h-11 rounded-bl-none rounded-tl-none border-l-0"
            variant="quiet"
            onClick={handleAddSelectItem}
          >
            <Icon name="plus" type="far" />
          </Button>
        </GroupTextField>
      </div>

      {rolesList.length > 0 && (
        <div className="w-full rounded-lg border border-neutral bg-neutral-object shadow-sm backdrop-blur p-1 mt-2">
          <ul className="px-2">
            {rolesList.map((item) => (
              <li
                key={item.id}
                className="flex items-center justify-between py-1"
              >
                <span className="text-base text-body-quiet">{item.name}</span>
                <Button
                  variant="ghost"
                  size="icon"
                  type="button"
                  aria-label="Eliminar"
                  className="shrink-0 inline-flex h-9 w-9 items-center justify-center rounded-full text-slate-500 hover:text-slate-700 hover:bg-slate-100 active:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-300"
                  onClick={() => handleRemoveSelectItem(item.id)}
                >
                  <Icon name="xmark" type="far" />
                </Button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};
